/*
 * @Author: lzh
 * @Date: 2022-09-15 11:28:55
 * @LastEditors: lbh
 * @LastEditTime: 2025-10-22 16:56:53
 * @Description: file content
 */
const en = {
  语言: "English",
  name: "name",
  info: {
    age: "man",
  },
  "Queue System": "Queue System",
  "Getting the number online and receiving notice":
    "Getting the number online and receiving notice",
  "Welcome Guest": "Welcome Guest",
  "Log in for queuing details via Phone number":
    "Log in for queuing details via Phone number",
  "Sign in_": "Sign in",
  Queue: "Queue",
  "Currently queuing": "Currently queuing",
  "Sorry, there is a temporarily suspension of queue service. Please contact the restaurant staff":
    "Sorry, there is a temporarily suspension of queue service. Please contact the restaurant staff",
  "Get number": "Tack number",
  "Enter your phone number": "Enter your phone number",
  "Enter your last 4-digits of phone number_":
    "Enter your last 4-digits of phone number",
  "Party size": "Party size",
  Confirm: "Confirm",
  Next: "Next",
  Cancel: "Cancel",
  Previous: "Previous",
  people: "people",
  awaitPeople: {
    key: "{x} tables left",
  },
  Continue: "Continue",
  "Whatsapp for queue status": "Whatsapp for queue status",
  Notice: "Notice",
  call_Number: "Number",
  call_Current: "Current",
  call_tables: "tables",
  Waiting: "Waiting",
  "Currently queuing": "Currently queuing",
  Restaurant: "Restaurant",
  Address: "Address",
  "Order time": "Order time",
  "You'll be there soon": "You'll be there soon",
  "Cancel line up": "Cancel ticket",
  "Take number": "Get ticket number",
  "again Take number": "Get ticket number",
  "Getting number successfully": "Successfully obtained ticket number",
  "Save credentials":
    "Save your ticket number in your mobile to avoid missing it",
  Confirm_: "Confirm",
  promptlySave: "Save",
  "Are you sure you want to cancel your queue number?":
    "Are you sure you want to cancel your queue number?",
  "It's time to eat!": "It's time to eat!",
  beingQueuing: "Queuing",
  call_Calling: "Calling",
  callPassed: "Expired",
  callSeated: "Seated",
  callCancelled: "Cancelled",
  awaitXToYour_: {
    key: "Still have {X} numbers will be your queue number ",
  },
  "The number has expired, please get it again":
    "The number has expired, please get it again",
  "Unable to access the page, please check the link for errors":
    "Unable to access the page, please check the link for errors",
  "Unable to access the page, please try again":
    "Unable to access the page, please try again",
  "You have confirmed": "You have confirmed",
  "Sign in and receiving WhatsApp Message":
    "Sign in now to unlock member benefits",
  "phone number": "phone number",
  "Please enter the phone number": "Enter your phone number",
  "I have read and agreed": "I have read and agreed",
  "Take number succeeded": "Take number succeeded",
  "Have dinner": "Number",
  "Screenshot to save the number": "Screenshot to save the number",
  "will be coming soon": "will be coming soon",
  "Enter your last 4-digits of phone number":
    "Enter your last 4-digits of phone number",
  "Enter a correct Phone Number": "Enter a correct Phone Number!",
  "Failed to get the number, please try again":
    "Failed to get the number, please try again",
  "There are active numbers": "There are active numbers",
  "Line up the details": "Detail",
  "No order at present": "No order at present",
  "No Data": "No Data",
  combo: {
    "Select x": "Select {X}",
    "Select x~y": "Select {X}~{Y}",
    "Select at least x": "Select at least {X}",
    "x Selected": "{X} Selected",
    Required: "Required",
    total: "Total",
    confirm: "Confirm",
    请至少选x项: "Please select at least {x} items",
    加配食品: "Additional Items",
    停: "Stop",
  },

  shop: {
    Address: "Address",
    Number: "Number",
    "Special Offer": "Special Offer",
    More: "More",
    "Please select address": "Please select address",
    OK: "OK",
    "Click the button in the upper right corner":
      "Click the button in the upper right corner",
    'Select "Open in browser"': 'Select "Open in browser"',
    "Open in browser": "Open in browser",
    Terms: "Terms",
    "Privacy Policy": "Privacy Policy",
    "© 2022 Gingersoft Limited. All rights reserved. No reproduction allowed.":
      "© 2022 Gingersoft Limited. All rights reserved. No reproduction allowed.",
    // * 盛記酒家
    "© 2024 Lucky Castle Limited. All rights reserved. No reproduction allowed.":
      "© 2024 Lucky Castle Limited. All rights reserved. No reproduction allowed.",
    "X Sold": "{X} Sold",
    "X Redeemed": "{X} Redeemed",
    "X Redeemed2": "{X} Redeemed",
    More2: "More",
    Redeemed: "Redeemed",
    "Use Now": "Use Now",
    "Sold Out": "Sold Out",
    Upcoming: "Upcoming",
    "Redeem Now": "Redeem Now",
    Details: "Details",
    "Available Restaurants": "Available Restaurants",
    "Business Hours": "Business Hours",
    Order: "Order",
    Coupon: "Coupon",
    Bookmark: "Bookmark",
    Language: "Language",
    Logout: "Logout",
    Login: "Login",
    "Failed to obtain address!": "Failed to obtain address!",
    Delivery: "Delivery",
    "Self pick up": "Take Out",
    "Cold Chain Delivery": "Cold Chain",
    "No available restaurants!": "No available restaurants!",
    Success: "Success",
    "Please go to my account-coupons to check":
      "Please go to my account-coupons to check",
  },
  orderDetail: {
    "Payment Method:": "Payment Method:",
    "Payment Method": "Payment Method",
    "Use Now": "Use Now",
    "Service Fee:": "Service Fee:",
    "Bill Decimal:": "Bill Decimal:",
    "Total X items": "Total {X} items",
    Total: "Total：",
    "Pay the remaining time": "Pay the remaining time", //支付剩余时间
    Order: "Order",
    createTime: "CreateTime",
    "Service amount": "Service amount：",
    "Bill Decimal": "Bill Decimal：",
    "Invite details": "Invite details",
    package_detail: "Details", // Details
    "Order cancelled": "Order cancelled",
    "Go to view": "Go to view",
    "Order Details": "Order Details", //訂單詳情
    "Order No": "Order No",
    "Solitary time": "Solitary time", //落單時間
    Reminder: "Reminder",
    // ! 2023-10-31
    Reminder: "Reminder",
    QRCode: "QRCode",
    StoreOrder: "StoreOrder",
    SkyOrder: "QRCode",
    PriorOrder: "PriorOrder",
    UsedCoupon: "UsedCoupon",
    "Member Discounts": "Member Discounts",
    "Restaurant Discounts": "Restaurant Discounts",
    "Automatic Discounts": "Automatic Discounts",
    Coupons: "Coupons",
    Wait: "Wait",
    "Payment completed": "Payment completed",
    Remaining: "Remaining",
    "Coupons have been distributed": "Coupons have been distributed",
    'Location: HomePage → "..." in the upper right corner → My coupons':
      'Location: HomePage → "..." in the upper right corner → My coupons',
    Details: "Details",
    "View more discounts：Ricepon App -> Coupon":
      "View more discounts：Ricepon App -> Coupon",
    "Please complete payment within X minutes":
      "Please complete payment within {X} minutes",
    "Save screenshot to photo album": "Save screenshot to photo album",
    "so you won’t lose it.": "so you won’t lose it.",
    "Save coupon to album": "Save coupon to album",
    "Save coupon to album2": "Save coupon to album",
    "Copied successfully": "Copied successfully",
    "The browser doesn’t support auto-copy.":
      "The browser doesn’t support auto-copy.",
    "QR code": "QR code",
    Paid: "Paid",
  },
  myCoupon: {
    "My coupon": "My coupon",
    Coupon: "Coupon",
    Available: "Available",
    "Please enter the discount code to redeem":
      "Please enter the discount code to redeem",
    Used: "Used",
    Expired: "Expired",
    "Redemption successful": "Redemption successful",
    "Check coupon status via WhatsApp": "Check coupon status via WhatsApp",
    Cancel: "Cancel",
    to: "to",
    price: "price",
  },
  couponDetail: {
    "Valid Min order of HK$X": "Valid Min order of HK$X",
    "X Sold": "{X} Sold",
    "X Redeemed": "{X} Redeemed",
    "X Redeemed2": "{X} Redeemed",
    "Includes X Coupons": "Includes {X} Coupons",
    "All shop": "All shop",
    "Only designated shop": "Only designated shop",
    "Valid until:": "Valid until:",
    "Available X days ": "Available {X} days ",
    "More Coupon": "More Coupon",
    "Valid until2:": "Valid until:",
    "Terms and Conditions": "Terms and Conditions",
    "More Terms and Conditions": "More Terms and Conditions",
    "Valid until3:": "Valid until:",
    "Available X days": "Available {X} days",
    "Related offers": "Related offers",
    "Only X coupons left": "Only {X} coupons left",
    Redeemed: "Redeemed",
    "Use Now": "Use Now",
    "Sold Out": "Sold Out",
    "Redeem Now": "Redeem Now",
    "Welcome Offer": "Welcome Offer",
    "Join Member": "Join Member",
    Buy: "Buy",
    "X Shop Available": "{X} Shop Available",
    "No address": "No address information available!",
    "By placing your order, you agree to the Terms and Conditions":
      "By placing your order, you agree to the Terms and Conditions",
    "Event Terms of Service": "Event Terms of Service",
    "I have read and agree X & Y": "I have read and agree {X} & {Y}",
    "I have read and agree": "I have read and agree",
    Confirm: "Confirm",
    Back: "Back",
  },
  refresh: {
    refreshUp: "Dropdown refreshes", //下拉可以刷新
    "Release refresh": "Release refresh", //釋放立即刷新
    Refreshing: "Refreshing...", //正在刷新...
    "Successfully loaded": "Successfully loaded",
    "Pull-up shows more": "Pull-up shows more", //上拉顯示更多
    "Loading...": "Loading...", //正在加載
    "No more data": "No more data", //沒有更多數據了
  },
  myAddress: {
    "Add address": "Add address",
  },
  message: {
    "Collection successful": "Collection successful!",
    "Canceled favorites": "Canceled favorites!",
    and: "and",
    selfBrand: "",
    "Brand Agreement": "Brand Agreement",
    "Ricepon Agreement": "Ricepon Agreement",
    Loading: "Loading...",
  },
  login: {
    "Bind mobile number": "Bind mobile number",
    "Successful SMS Sending!": "Successful SMS Sending!",
    "Binding success!": "Binding success!",
    "Enter a correct Phone Number": "Enter a correct Phone Number",
    "Phone number": "Phone number",
    "Enter verification code": "Enter verification code",
    "Send verify code": "Send verify code",
    "phone number": "phone number",
    Captcha: "Captcha",
    Confirm: "Confirm",
    "SMS verification code error": "SMS verification code error!",
    "Member login error times too many, please try again later":
      "Member login error times too many, please try again later!",
    "Your account has been suspended, please contact customer service email!":
      "Your account has been suspended, please contact customer service email!",
    "Network request timeout! Please refresh and try again!":
      "Network request timeout! Please refresh and try again!",
    "Your account hasexpired, please contact customer service email!":
      "Your account hasexpired, please contact customer service email!",
    "Binding Mobile Phone Number": "Bind mobile number",
    "phone number 2": "Phone number",
    "Phone number": "Phone number",
    bindSuccess: "Binding success!",
    Back: "Back",
    Agree: "Agree",
    googleBindTitle: "Bind your Google account",
    googleBindSubtitle:
      "Please bind once first. After that, you can sign in with Google directly next time without SMS verification.",
    googleBindAccountName: "Google Account",
    googleBindAccountLinked: "Google account linked",
    googleBindWithSms: "Bind with SMS",
    googleBindWithPassword: "Bind with password",
    googleBindPasswordLabel: "Password",
    googleBindPasswordPlaceholder: "Please enter your password",
    googleBindHelpTitle: "Need help?",
    googleBindHelpText:
      "If you already set a password, you can bind with password directly. If you have not registered or have not set a password yet, you can use SMS to complete registration or binding.",
    googleBindExpired: "Google bind session expired, please sign in again",
    googleBindInvalidPhone: "Please enter a valid phone number",
    googleBindPasswordRequired: "Please enter your password",
    googleBindFailed: "Google bind failed",
    googleBindPasswordFailed: "Password bind failed",
    googleBindSuccess: "Bind success",
    googleBindContinue: "Continue",
    googleBindBusy: "Please try again later",
    googleMemberNotFound: "Member not found, please try again later",
    googleAccountAlreadyBound:
      "This Google account is already linked to another account",
    googleMemberAlreadyBoundOther:
      "This member is already linked to another Google account",
    googleLoginFailed: "Google sign-in failed",
    googleLoginFailedRetry:
      "Google sign-in failed, please try password or SMS login",
    googleLoginUnavailable: "Google sign-in is temporarily unavailable",
    googleOpenInBrowser:
      "This browser does not support Google sign-in. Please open this page in your system browser and try again.",
    googleNeedAgree: "Please agree to the terms first",
    googleAgreeAndContinue:
      "You need to agree to the terms first. Agree now and continue with Google sign-in?",
    googleAgreeAndContinuePrefix: "Do you agree to",
    googleAgreeAndContinueSuffix: "and continue with Google sign-in?",
    googleClientIdTip:
      "Google sign-in will be available after VUE_APP_GOOGLE_CLIENT_ID is configured.",
    googleRecommended: "Recommended: Google sign-in",
    googleRecommendedDesc: "Skip waiting for SMS and complete sign-in faster.",
    googleButtonLabel: "Continue with Google",
    Use_Google_or_WhatsApp_to_log_in_quickly: "Quick sign in with Google or WhatsApp",
    Use_WhatsApp_to_log_in: "Continue with WhatsApp",
    SMS_login: "SMS sign in",
    WhatsApp_login_register: "WhatsApp Sign in / Sign up",
    Enter_WhatsApp_phone_number: "Enter your WhatsApp phone number",
    Enter_WhatsApp_verification_code: "Enter your WhatsApp verification code",
    googleConfirmTitle: "Google Sign in / Sign up",
    googleConfirmSubtitle: "Agree to the terms and continue with Google authorization sign-in",
    googleConfirmCancel: "Think again",
    googleConfirmAgree: "I agree",
    googleAltLogin: "Or continue with SMS login",
    googleLoading: "Loading Google sign-in...",
    googleRedirecting: "Redirecting to Google...",
    bindMobileDescription: "Quick login with WhatsApp",
    unregisteredAutoRegister: "Unregistered mobile phone number will be automatically registered",
    smsLoginLabel: "SMS",
    passwordLoginLabel: "PassWord",
    loginActionText: "Login",
    whatsappVerifyLogin: "WhatsApp Verification Login",
    safeAuthTip: "Fast, secure, one-tap authorization",
    passwordSafeTip: "Secure login with password",
    switchOtherMethods: "Or switch to other methods",
    forgotPasswordLabel: "Forgot password?",
    pasteOtpConfirm: "Paste {code}?",
    nextStep: "Next",
    registerLogin: "Register/Login",
    welcomeTo: "Welcome to",
    memberRewardsTip:
      "Become a member, earn points, and enjoy exclusive offers~",
    passwordLogin: "Password login",
    smsLogin: "SMS login",
    forgotPassword: "Forgot password?",
    pleaseEnterPassword: "Please enter password",
    pleaseAgreeAgreement: "Please agree to the agreement",
    loginSuccess: "Login successful",
    retrievePassword: "Retrieve password",
    forgotPasswordPrompt:
      "Forgot your password? You can retrieve it through your phone number!",
    setPassword: "Set password",
    pleaseSetPassword: "Please set password",
    confirmPassword: "Confirm password",
    pleaseConfirmPassword: "Please confirm password",
    phoneIncorrect: "Phone number incorrect",
    passwordsNotMatch: "Passwords do not match",
    passwordResetSuccess: "Password reset successful",
    passwordResetFailed: "Password reset failed",
    next: "Next",
    step2SetPassword: "2/3 Set a password for future login",
    passwordLengthGt6: "Password length must be greater than 6",
    confirmPasswordNotMatch: "Confirm password does not match",
    completeRegistration: "Complete registration",
    completeProfile: "Complete profile",
    step3CompleteProfile:
      "3/3 Complete your profile for a better service experience~",
    memberName: "Member name",
    pleaseEnterMemberName: "Please enter member name",
    gender: "Gender",
    male: "Male",
    female: "Female",
    birthday: "Birthday",
    pleaseSelectBirthday: "Please select birthday",
    pleaseEnterEmail: "Please enter email address",
    selectDate: "Select date",
    pleaseSelectGender: "Please select gender",
    networkRetryLogin: "Network issue occurred, please retry login!",
    registrationExpired:
      "Registration information has expired, please register again!",
    updateProfileSuccess: "Profile updated successfully",
    welcomeBack: "Welcome back",
    platformPoweredByRicepon: "This platform is powered by Ricepon",
    riceponAccountSyncDesc:
      "We detected that you are already a Ricepon user. To help you start quickly, we will sync your account information.",
    dataSource: "Data source",
    dataSourceDesc:
      "Your profile and coupon information shown here are securely provided by Ricepon.",
    privacySecurity: "Privacy security",
    privacySecurityDesc:
      "Together with Ricepon, we strictly protect your data security and only use it to provide this service.",
    smsCodeError: "SMS verification code error!",
    memberLoginErrorTooMany:
      "Member login error times too many, please try again later!",
    accountSuspended:
      "Your account has been suspended, please contact customer service email!",
    accountExpired:
      "Your account hasexpired, please contact customer service email!",
    phoneNumberLabel: "Phone number",
    passwordLabel: "Password",
    enterPhoneNumber: "Please enter phone number",
    enterVerificationCode: "Please enter verification code",
    enterCorrectPhone: "Please enter a correct phone number",
    captchaLabel: "Verification code",
    sendVerifyCode: "Send verify code",
    resendVerifyCode: "Resend verify code",
    sendCodeFailed: "Failed to send verification code",
    pleaseSendVerificationCode: "Please send verification code first",
    verificationCodeFormatError: "Verification code format error",
    verificationPassed: "Verification passed",
    googleBindTitle: "Bind your Google account",
    googleBindSubtitle:
      "Please bind once first. After that, you can sign in with Google directly next time without SMS verification.",
    googleBindAccountName: "Google Account",
    googleBindAccountLinked: "Google account linked",
    googleBindWithSms: "Bind with SMS",
    googleBindWithPassword: "Bind with password",
    googleBindPasswordLabel: "Password",
    googleBindPasswordPlaceholder: "Please enter your password",
    googleBindHelpTitle: "Need help?",
    googleBindHelpText:
      "If you already set a password, you can bind with password directly. If you have not registered or have not set a password yet, you can use SMS to complete registration or binding.",
    googleBindExpired: "Google bind session expired, please sign in again",
    googleBindInvalidPhone: "Please enter a valid phone number",
    googleBindPasswordRequired: "Please enter your password",
    googleBindFailed: "Google bind failed",
    googleBindPasswordFailed: "Password bind failed",
    googleBindSuccess: "Bind success",
    googleBindContinue: "Continue",
    googleBindBusy: "Please try again later",
    googleMemberNotFound: "Member not found, please try again later",
    googleAccountAlreadyBound: "This Google account is already linked to another account",
    googleMemberAlreadyBoundOther: "This member is already linked to another Google account",
    googleLoginFailed: "Google sign-in failed",
    googleLoginFailedRetry: "Google sign-in failed, please try password or SMS login",
    googleLoginUnavailable: "Google sign-in is temporarily unavailable",
    googleOpenInBrowser: "This browser does not support Google sign-in. Please open this page in your system browser and try again.",
    googleNeedAgree: "Please agree to the terms first",
    googleAgreeAndContinue: "You need to agree to the terms first. Agree now and continue with Google sign-in?",
    googleAgreeAndContinuePrefix: "Do you agree to",
    googleAgreeAndContinueSuffix: "and continue with Google sign-in?",
    googleClientIdTip: "Google sign-in will be available after VUE_APP_GOOGLE_CLIENT_ID is configured.",
  googleRecommended: "Recommended: Google sign-in",
  googleRecommendedDesc: "Skip waiting for SMS and complete sign-in faster.",
    googleButtonLabel: "Continue with Google",
    googleConfirmTitle: "Google Sign in / Sign up",
    googleConfirmSubtitle: "Agree to the terms and continue with Google authorization sign-in",
    googleConfirmCancel: "Think again",
    googleConfirmAgree: "I agree",
    googleAltLogin: "Or continue with SMS login",
    googleLoading: "Loading Google sign-in...",
    googleRedirecting: "Redirecting to Google...",
    bindMobileDescription: "Quick login with WhatsApp",
    unregisteredAutoRegister: "Unregistered mobile phone number will be automatically registered",
    smsLoginLabel: "SMS",
    passwordLoginLabel: "PassWord",
    loginActionText: "Login",
    whatsappVerifyLogin: "WhatsApp Verification Login",
    safeAuthTip: "Fast, secure, one-tap authorization",
    passwordSafeTip: "Secure login with password",
    switchOtherMethods: "Or switch to other methods",
    forgotPasswordLabel: "Forgot password?",
    pasteOtpConfirm: "Paste {code}?",
    nextStep: "Next",
  },
  payPopup: {
    RefreshPaymentResult: "Refresh payment result",
    Paying: "Paying",
    "Submitted, please wait patiently": "Submitted, please wait patiently",
    Cancelled: "Cancelled",
    "Cancellation failed": "Cancellation failed",
    Paid: "Paid",
  },
  map: {
    "Please enable location permission in browser settings":
      "Please enable location permission in browser settings",
    "The request for location was denied.":
      "The request for location was denied.",
    "Location is unavailable.": "Location is unavailable.",
    "The request for location timed out.":
      "The request for location timed out.",
    "Unknown error.": "Unknown error.",
    "Current browser does not support getting location":
      "Current browser does not support getting location",
    View_Google_Navigation: "View Google Navigation",
  },
  area: {
    HongKong: "HongKong",
    Singapore: "Singapore",
    Macau: "Macau",
    China: "China",
    Japan: "Japan",
    Korea: "Korea",
    Thailand: "Thailand",
  },
  invite: {
    submitted: "submitted",
    "Merchant has confirmed": "Merchant has confirmed",
    "Meal available": "Meal available",
    Tel: "Tel",
    "Please wait patiently for the merchant to confirm, and pick up the meal according to the meal code. If the meal code is not displayed, please try to refresh":
      "Please wait patiently for the merchant to confirm, and pick up the meal according to the meal code. If the meal code is not displayed, please try to refresh",
    "Contact merchant": "Contact merchant", //联系商家
    Cancelled: "Cancelled",
    "Subscribe to notification messages using WhatsApp":
      "Subscribe to notification messages using WhatsApp",
  },
  confirm: {
    Warm_prompt: "Reminder",
    cap_Confirm: "Confirm",
  },
  account: {
    昵称: "Nickname",
    修改昵称: "Change nickname",
    请输入昵称: "Please enter a nickname",
    邮件: "Mail",
    修改邮件: "Modify email",
    请输入邮件: "Please enter email",
    请输入正确的邮件地址: "Please enter the correct email address",
    生日: "Birthday",
    修改生日: "Change birthday",
    修改成功: "Modified successfully",
    温馨提示: "Reminder",
    品牌协议: "Brand Agreement",
    切换语言: "Switch language",
    登出: "Logout",
    登入: "Login",
    请先登入: "Please log in first~",
    切换字体: "Switch Fonts",
  },
  tabBar: {
    首页: "Home",
    点单: "Ordering",
    订单: "Order",
    账户: "Account",
  },
  tabBarBrand: "Brand",
  pay: {
    支付金额应大于0: "The payment amount should be greater than 0",
  },
  order: {
    更多: "More...",
    共X份: "Total {x} items,Total: {n}",
    取消订单: "Cancel",
    申请退款: "Apply for refund",
    联络餐厅: "Contact merchant",
    去支付: "Pay",
    退款进度: "Refund progress:",
    取消原因: "Reason for Cancellation:",
    堂食: "Eat In",
    外送: "Take Away",
    自取: "Self pick up",
    冷冻派送: "Cold Chain Delivery",
    待支付: "Pay here",
    已提交: "Submitted",
    待确认: "to be confirmed",
    製作中: "In production",
    待取餐: "Waiting for meal",
    已完成: "Completed",
    已取消: "Order cancelled",
    外卖自取: "Take Away",
    取餐信息: "Food information",
    评价: "Evaluation",
    订单码: "Order code",
    投票: "vote",
    投票历史: "Voting history",
    商家已确认不可取消: "Order confirmed, cannot cancel",
    取消成功: "Order cancelled!",
    确定取消订单: "Are you sure to cancel?",
    等待确认: "Waiting for confirmation",
    等待付款: "wait for payment",
    订单已完成: "Order completed",
    待取餐: "Waiting for meal",
    派送中: "Delivery of",
    已送达: "It has been served",
    退款处理中: "Refund processing",
    预计5到7天内退款完成:
      "It is expected that the refund will be completed within 5-7 days",
    预计1到3个工作日内退款完成:
      "The refund is expected to be completed within 1-3 working days",
    退款已完成: "Refund completed",
    退款中: "Refunding",
    外卖订单: "Takeaway order",
    店铺订单: "Shop Order",
    扫码点餐: "Sky Order",
    已完结: "Finished",
    已取餐: "Taken meals",
    购买等级: "Purchase level",
    已取餐: "Meal has been taken",
    團購券: "Group-buy voucher",
    可使用: "Available",
  },
  orderList: {
    all: "All",
    pendingPayment: "Wait for payment",
    toBeEvaluatedOrVoted: "To be evaluated / voted",
    loading: "Loading...",
    empty: "No order at present",
  },
  barcode: {
    可前往埋單機掃賬單碼支付訂單: "Scan the bill barcode at the kiosk to pay for this order",
    點擊查看賬單碼: "Tap to view bill barcode",
    請到埋單機掃下方賬單碼支付訂單: "Please scan the bill barcode below at the kiosk to pay for this order",
    賬單碼: "Bill barcode",
  },
  couponTag: {
    減: "-",
    OFF: "OFF",
  },
  mealFood: {
    加购享优惠: "Discount",
    撞餐優惠金額結賬時進行計算:
      "The meal discount amount will be calculated when you check out.",
  },
  queue: {
    暂不支持X取号: "{X} level retrieval is not currently supported!",
    取号记录: "Queue history",
    还需等待x桌: "Still have {X} tables left",
    排队中: "In line",
    呼叫中: "Calling",
    已过号: "Over",
    已入座: "Seated",
    已取消: "Cancelled",
    请耐心等候: "Thank you for your patience, we are preparing your table.",
    请与餐厅职员联络:
      "Sorry, the restaurant has temporarily suspended the number collection service. If you have any questions, please contact the restaurant staff.",
    优先轮候: "Priority waiting",
    普通会员: "Ordinary Member",
    X优先取票: "“{X}”priority ticket collection",
    您的会员等级不足: "Your membership level is not sufficient",
    仅支持X优先轮候: "Only supports {X} priority queue",
    知道了: "Close",
    温馨提示: "Kind tips",
    超出限制:
      "Your queue number at the current restaurant has exceeded the limit. Please cancel and try again.",
    已取过号了:
      "You have already queued up at {X} restaurant. Do you want to cancel the queue at this restaurant?",
    再想想: "Think again",
    取消排队: "Cancel queue",
    请选择用餐时段: "Please select a meal time",
    取消成功: "Cancel Success",
    网络似乎开小差了: "The network seems to be down, please try again later!",
    补票中: "Restoring",
    未齐人号码保留中: "Reserving",
    餐厅优惠: "Restaurant offers",
    更多: "More",
    公告: "announcement",
    请输入用餐人数: "Please insert number of guests",
    请输入会员Id: "Please insert MGM member ID",
    取号成功: "Successfully obtained ticket number",
    请通过以下方式获取排队进度提醒:
      "Please select one of the following methods to receive queue status notifications.",
    请选择以下获取排队提醒方式:
      "Please select the following method to get queue reminder",
    微信通知: "WeChat",
    获取短信提醒: "notifications via SMS",
    请输入你要获取排队动态的电话号码:
      "Please provide the mobile number you'd like to use for queue status notifications.",
    确定: "Confirm",
    请输入正确的手机号: "Please enter a valid mobile phone number",
    微信订阅成功: "WeChat subscription successful",
    微信订阅失败: "WeChat subscription failed",
    短信订阅成功: "SMS subscription successful",
    短信订阅失败: "SMS subscription failed",
    跳过: "Skip",
    获取排队通知:
      "Avoid missing the seating opportunity, please get queue notification",
    餐厅地址: "Restaurant Address",
    餐厅名称: "Restaurant name",
    用餐人数: "No. of guests",
    取号时间: "Ticket time",
    X人: "{X} people",
    联络电话: "Contact number",
    用餐号: "Ticket number",
    是否确认取消轮候: "Confirm cancellation?",
    MGM_确认取消: "Confirm",
    MGM_否: "Cancel",
    X人: "{X} persons",
    X人以上: "{X} persons or above",
    X到Y人: "{X}~{Y} persons",
    点击这里以短讯接收通知: "Click here to receive notifications via SMS",
    接收短讯可能产生电讯商费用: "(your own carrier charges may apply)",
    获取提醒表示接受X: "By receiving notifications, I hereby agree the {X}",
    私隐条款: "Privacy Terms",
  },
  WhatsApp: {
    感谢惠顾: "Thank you for your patronage",
    X为你送上Y张优惠券: "{X} sent you {Y} coupons",
    前往领取: "Go to collect",
  },
};
export default en;





